import { ActionLogRepositoryImpl } from "../data/ActionLogRepositoryImpl";
import { IActionLogRepository } from "../domain/repositories/IActionLogRepository";
import { ActionLogUseCase } from "../domain/useCases/ActionLogUseCase";
import { ActionLogViewModel } from "../presentation/viewModel/ActionLogViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class ActionLogInjection extends InjectionModule {
  private static readonly actionLogRepositoryToken = Symbol(
    "IActionLogRepository",
  );
  private static readonly actionLogUseCaseToken = Symbol("ActionLogUseCase");
  private static readonly actionLogViewModelToken =
    Symbol("ActionLogViewModel");

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.actionLogRepositoryToken,
      useClass: ActionLogRepositoryImpl,
    },
    {
      scope: "otherRepo",
      token: this.actionLogUseCaseToken,
      useClass: ActionLogUseCase,
    },
    {
      scope: "viewModel",
      token: this.actionLogViewModelToken,
      useClass: ActionLogViewModel,
    },
  ];

  static getRepo() {
    return this.resolve<IActionLogRepository>(this.actionLogRepositoryToken);
  }

  static getUseCase() {
    return this.resolve<ActionLogUseCase>(this.actionLogUseCaseToken);
  }
}
